/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../shared/first_party_addons';
import '../data/installation_action_source';
import '../data/source_details';
import './addon_response_status';
import '../data/localized_addon';
import '../data/addon_status_for_seller';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "addons": {
        "nested": {
          "external": {
            "nested": {
              "InstallAddonRequest": {
                "fields": {
                  "firstPartyAddon": {
                    "type": ".squareup.addons.shared.FirstPartyAddon",
                    "id": 1,
                    "rule": "optional"
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "shouldEnable": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "actingEmployeeToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "actionSource": {
                    "type": ".squareup.addons.data.InstallationActionSource",
                    "id": 5,
                    "rule": "optional"
                  },
                  "populateAddonInResponse": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "sourceDetails": {
                    "type": ".squareup.addons.data.SourceDetails",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "InstallAddonResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "localizedErrorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "addonResponseStatus": {
                    "type": ".squareup.addons.external.AddonResponseStatus",
                    "id": 3,
                    "rule": "optional"
                  },
                  "addon": {
                    "type": ".squareup.addons.data.LocalizedAddon",
                    "id": 4,
                    "rule": "optional"
                  },
                  "allAddonVerticals": {
                    "type": ".squareup.addons.data.LocalizedVertical",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "statusForSeller": {
                    "type": ".squareup.addons.data.AddonStatusForSeller",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.addons?.nested?.external?.nested?.InstallAddonRequest && !$root.nested?.squareup?.nested?.addons?.nested?.external?.nested?.InstallAddonResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE InstallAddonRequest @ squareup/addons/external/install_addon.proto at 16:1
 */
export const InstallAddonRequest = $root.lookupType('squareup.addons.external.InstallAddonRequest');
fixType(InstallAddonRequest, {
  idempotenceKey: {
    required: true
  }
});
Builder.createAndAttachToType(InstallAddonRequest);
/**
 * SOURCE InstallAddonResponse @ squareup/addons/external/install_addon.proto at 34:1
 */
export const InstallAddonResponse = $root.lookupType('squareup.addons.external.InstallAddonResponse');
fixType(InstallAddonResponse, {
  success: {
    required: true
  }
});
Builder.createAndAttachToType(InstallAddonResponse);